/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a sample in the online editor. Save a file before closing the session.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在在线编辑器中启动示例，关闭会话前保存文件。`)
};

/**
* | output |
* | --- |
* | "Launch a sample in the online editor. Save a file before closing the session." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_0_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_0_1 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.0.1" }